import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { EnvironmentService } from './environment.service';

export interface ModelProfileSummary {
  profileId: string;
  displayName: string;
  modelName: string;
  description: string;
  temperature: number;
  maxOutputTokens: number;
}

export interface UseCaseDefault {
  useCase: string;
  displayName: string;
  defaultProfileId: string;
  roleDefaults: Record<string, string>;
}

export interface ModelConfigDefaults {
  profiles: ModelProfileSummary[];
  useCaseDefaults: UseCaseDefault[];
}

export interface UseCaseModelAssignment {
  useCase: string;
  profileId: string;
  roleProfiles: Record<string, string>;
}

export interface ProjectModelConfig {
  useCaseOverrides: UseCaseModelAssignment[];
}

/** Fetches model profile metadata and use-case defaults from the backend (Issue #1020). */
@Injectable({
  providedIn: 'root',
})
export class ModelConfigService {
  private http = inject(HttpClient);
  private env = inject(EnvironmentService);
  private baseUrl: string;

  constructor() {
    this.baseUrl = `https://${this.env.getApiServer()}`;
  }

  getModelConfigDefaults(): Observable<ModelConfigDefaults> {
    return this.http.get<ModelConfigDefaults>(`${this.baseUrl}/v1/model-config/defaults`).pipe(
      map(response => ({
        profiles: (response.profiles || []).map(p => ({
          ...p,
          temperature: p.temperature ?? 0,
          maxOutputTokens: p.maxOutputTokens ?? 0,
        })),
        useCaseDefaults: (response.useCaseDefaults || []).map(uc => ({
          ...uc,
          roleDefaults: uc.roleDefaults || {},
        })),
      }))
    );
  }
}
